import React from 'react'

import MaintenanceModePage from 'app/BCKSPage/MaintenanceMode'
import { SelfProposalPage } from 'app/BCKSPage/SelfProposal/SelfProposalPage'
import { isToggleEnabled } from 'configs/toggle-feature'

interface PageProps {
  isKSSelectionEnabled: boolean
}

export const getServerSideProps = async () => {
  const isKSSelectionEnabled = await isToggleEnabled('ks-selection-enabled')

  return {
    props: {
      isKSSelectionEnabled,
    },
  }
}

const Page = (props: PageProps) => {
  if (!props.isKSSelectionEnabled) {
    return <MaintenanceModePage />
  }

  return <SelfProposalPage />
}

// eslint-disable-next-line react/display-name
Page.Layout = ({ children }: { children: React.ReactNode }) => <>{children}</>

export default Page
